import * as autoComplete from '@tarekraafat/autocomplete.js/dist/js/autoComplete';
import 'whatwg-fetch';

export default (input, inputId) => {
  const { placeholder } = input;

  return new autoComplete({
    data: {
      src: () => {
        // Loading placeholder text
        input.setAttribute('placeholder', placeholder);

        return fetch(`${wp_data.apiUrl}${encodeURIComponent(input.value)}`)
          .then(response => response.json())
          .then((response) => {
            input.setAttribute('placeholder', placeholder);

            return response.data;
          });
      },
      key: ['organisatie'],
      cache: false,
    },
    sort: (a, b) => {
      if (a.match < b.match) return -1;
      if (a.match > b.match) return 1;
      return 0;
    },
    placeHolder: placeholder,
    selector: `[name="${input.name}"]`,
    threshold: 0,
    debounce: 350,
    searchEngine: 'strict',
    highlight: true,
    maxResults: 10,
    resultsList: {
      render: true,
      container: source => source.classList.add('m-company-autocomplete__list'),
      destination: input,
      position: 'afterend',
      element: 'ul',
    },
    resultItem: {
      content: (data, source) => {
        source.classList.add('m-company-autocomplete__result');
        source.innerText = data.value.organisatie;

        source.appendChild(document.createElement('br'));

        const smallEl = document.createElement('small');
        smallEl.innerText = data.value.city;
        source.appendChild(smallEl);
      },
      element: 'li',
    },
    noResults: () => {}, // Do nothing
    onSelection: (feedback) => {
      input.value = feedback.selection.value.organisatie;
      inputId.value = feedback.selection.value.id.substring(0, 8);
    },
  });
};

// const inputs = document.querySelectorAll('#companyName');

// if (inputs) {
//   for (let i = 0; i < inputs.length; i++) {
//     autocompleteCompanyInput(inputs[i]);
//   }
// }
